// extracted by mini-css-extract-plugin
module.exports = {"ArticleText":"ArticleText_ArticleText__91HDv"};